import React from 'react';
import Register from './pages/Register';
import Report from './pages/Report';
import Login from './pages/Login';
import Request from './pages/Request';
import { Routes, Route } from 'react-router-dom';  
import { UserProvider } from './UserContext';
import Protected from './components/Protected';
import Map from './pages/Map';
import ViewRequest from './pages/ViewRequest';
import CreateAdmin from './pages/CreateAdmin';
import UpdateBooking from './pages/UpdateBooking';
import FullDetails from './pages/FullDetails';
import Inbox from './pages/Inbox';
import InboxDetails from './pages/InboxDetails';
import CancelRequest from './pages/CancelRequest';
import ReopenRequest from './pages/ReopenRequest';
import FeedbackSurvey from './pages/FeedbackSurvey';
import CourierDetails from './pages/CourierDetails';

export default function App() {
  return (
    <div>
      <UserProvider>
        <Routes>

          {/* Report */}
          <Route path="/report" element={<Protected />}>
            <Route path="/report" element={<Report />} />
          </Route>

          {/* Login */}
          <Route path="/login" element={<Login />} />

          {/* Register */}
          <Route path="/register" element={<Register />} />

          {/* Home / View Request */}
          <Route path="/" element={<Protected />}>
            <Route path="/" element={<ViewRequest />} />
          </Route>

          <Route element={<Protected />}>
            <Route path="/inbox" element={<Inbox />} />
            <Route path="/inbox/:requestId" element={<InboxDetails />} />
          </Route>

          {/* Create Request */}
          <Route path="/create-request" element={<Protected />}>
            <Route path="/create-request/:requestId?" element={<Request />} />
          </Route>

          {/* Planner */}
          <Route path="/planner" element={<Protected />}>
            <Route path="/planner/:requestId?" element={<Map />} />
          </Route>

          {/* Create Admin */}
          <Route path="/create-admin" element={<Protected />}>
            <Route path="/create-admin" element={<CreateAdmin />} />
          </Route>

          {/* Booking Details */}
          <Route path="/booking-details" element={<Protected />}>
            <Route path="/booking-details/:requestId?" element={<UpdateBooking />} />
          </Route>

          {/* Full Details */}
         <Route element={<Protected />}>
            <Route path="/full-details/:requestId?" element={<FullDetails />} />
            </Route>

          {/* Courier Details */}
          <Route path="/courier-details" element={<Protected />}>
            <Route path="/courier-details/:requestId?" element={<CourierDetails />} />
          </Route>

          {/* Cancel Request */}
          <Route path="/cancel-request" element={<Protected />}>
            <Route path="/cancel-request/:requestId?" element={<CancelRequest />} />
          </Route>

          {/* Reopen Request */}
          <Route path="/reopen-request" element={<Protected />}>
            <Route path="/reopen-request/:requestId?" element={<ReopenRequest />} />
          </Route>

          {/* Feedback */}
          <Route path="/feedback" element={<Protected />}>
            <Route path="/feedback" element={<FeedbackSurvey />} />
          </Route>

        </Routes>
      </UserProvider>
    </div>
  );
}
